import React from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useModal } from "context/ModalContext";
import { dateTimeFormatterReturnDateOnly } from "utilities";
import UnitsUsersDetailModal from "app/routes/Sites/routes/Display/UnitsUsers/UnitsUsersDetailModal";

const SharedUserDetailModal = ({uuDetail}) => {
  const intl = useIntl();
  const { openModal } = useModal();
  const authUser = useSelector(state => state.auth.authUser);
  const site = useSelector(state => state.auth.site);
  const userTimezone = useSelector(state => state.app.userTimezone);

  return (
    <div className="px-14 flex flex-col gap-6 py-4 min-h-[300px]">
      {uuDetail.sharedUsers.map(u => (
        <div
          key={u.id}
          className="grid grid-cols-3 cursor-pointer"
          onClick={() => {
            openModal(
              <UnitsUsersDetailModal
                trigger={`${u.id}-${Date.now()}`}
                unitUser={{ User: u }}
              />
            );
          }}
        >
          <p className="tw-desc-reg font-semibold text-left">{u.firstName} {u.lastName}</p>
          <p className="tw-desc-reg text-center">{intl.formatMessage({ id: "form.addedBy" })} {uuDetail.unit.User.fullName}</p>
          <p className="tw-desc-reg text-right">{dateTimeFormatterReturnDateOnly(u.dateShared, authUser, site, userTimezone)}</p>
        </div>
      ))}
    </div>
  )
}

export default SharedUserDetailModal;